import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

// router.js
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 增强 push 方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        // 处理参数变化的情况
        if (err.name === 'NavigationDuplicated') {
            // 检查是否是参数变化的情况
            const current = this.currentRoute;
            if (
                location.name === current.name &&
                JSON.stringify(location.params) !== JSON.stringify(current.params)
            ) {
                // 参数变化时，强制刷新
                return originalReplace.call(this, {
                    ...location,
                    query: {
                        ...location.query,
                        timestamp: Date.now() // 添加时间戳确保唯一性
                    }
                });
            }
        }
        throw err;
    });
};

// 同样处理 replace 方法
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name === 'NavigationDuplicated') {
            const current = this.currentRoute;
            if (
                location.name === current.name &&
                JSON.stringify(location.params) !== JSON.stringify(current.params)
            ) {
                return originalReplace.call(this, {
                    ...location,
                    query: {
                        ...location.query,
                        timestamp: Date.now()
                    }
                });
            }
        }
        throw err;
    });
};

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('@/views/Index.vue')
    },
    {
        path: '/signal',
        name: 'Signal',  // 添加路由名称
        component: () => import('@/views/Signal.vue')
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    console.log(to)
    let toPath = to.path;
    if (toPath === '/signal') {
        let type = to.query.type;
        store.commit("setActiveIndex", parseInt(type));
    }
    if (toPath === '/') {
        store.commit("setActiveIndex", 0);
    }
    next()
})

export default router
